// Central image resolver: matches an item/service to a themed photo by deity,
// occasion, content type or service kind. Uses proven hotlink-safe URLs.
export const PIC = {
  manuscript: "https://static.prod-images.emergentagent.com/jobs/f79bd64e-30d1-4119-8097-970fcb1907b0/images/c332f168c204d952d0c6a6d2c551fccd0291a78361a35f6ba15f0ef48a89b469.jpeg",
  // Deity artwork (traditional Tanjore/Pattachitra-style, generated respectfully)
  shiva: "https://static.prod-images.emergentagent.com/jobs/f79bd64e-30d1-4119-8097-970fcb1907b0/images/f852f62d7c5c311b1c8d0b4c21fe1e287da1d572b63250ba7b4cce29c389838b.jpeg",
  vishnu: "https://static.prod-images.emergentagent.com/jobs/f79bd64e-30d1-4119-8097-970fcb1907b0/images/70168ad11949f341597b63a98546fc5e4e8e420bae084e7fd214d28a53362e73.jpeg",
  krishna: "https://static.prod-images.emergentagent.com/jobs/f79bd64e-30d1-4119-8097-970fcb1907b0/images/d3ce739d1793509a1b092f70d91765cfa507d8727efc48d534e2ab76869749d4.jpeg",
  rama: "https://static.prod-images.emergentagent.com/jobs/f79bd64e-30d1-4119-8097-970fcb1907b0/images/b19543b85b8a2fe9990649fb8a02b9cdfcdd3e8c46a42e76123b79956ee1caa0.jpeg",
  devi: "https://static.prod-images.emergentagent.com/jobs/f79bd64e-30d1-4119-8097-970fcb1907b0/images/11dda34d81d588a5b2f2ea7246ab9bf908ed78eed6dc6394a16745821aa8b297.jpeg",
  lakshmi: "https://static.prod-images.emergentagent.com/jobs/f79bd64e-30d1-4119-8097-970fcb1907b0/images/247936cb7d15c9db46f07d6781dac89c9dbeb239d2cda07e920e097da120cdf1.jpeg",
  saraswati: "https://static.prod-images.emergentagent.com/jobs/f79bd64e-30d1-4119-8097-970fcb1907b0/images/b4d50dcbd032f89d25dbb9a640e81fa0d47e7fdd51b1e4c5dc69ee700443630b.jpeg",
  ganesha: "https://static.prod-images.emergentagent.com/jobs/f79bd64e-30d1-4119-8097-970fcb1907b0/images/b317597af8a84921b1bb80fdd0b0c88f5a86303a530aa791fb66dda127677307.jpeg",
  hanuman: "https://static.prod-images.emergentagent.com/jobs/f79bd64e-30d1-4119-8097-970fcb1907b0/images/1d2e28ab5de50a46981a8ae63cc633ab53ee2a2d6bcf6a5e0fd86433531b6a3d.jpeg",
  surya: "https://static.prod-images.emergentagent.com/jobs/f79bd64e-30d1-4119-8097-970fcb1907b0/images/08ec08c6905111a37b317314c830e5e94f785e11849d722ad53323fa67dcbd94.jpeg",
  // Content-type / hero art
  pujaArt: "https://static.prod-images.emergentagent.com/jobs/f79bd64e-30d1-4119-8097-970fcb1907b0/images/af048674a8138ab0df14abfe1ea3c46bc5d8d5cdfd5515b752e8b8d44f819bb1.jpeg",
  mantraArt: "https://static.prod-images.emergentagent.com/jobs/f79bd64e-30d1-4119-8097-970fcb1907b0/images/7204d6c84cef191f1410dafe748e6da7113a6e1372f3c6be4e7b5c87289a1138.jpeg",
  stotraArt: "https://static.prod-images.emergentagent.com/jobs/f79bd64e-30d1-4119-8097-970fcb1907b0/images/a260b139735e6e2245b5af8ecf7091a515be78759fbae9790ab20b1c1aa933f9.jpeg",
  festivalArt: "https://static.prod-images.emergentagent.com/jobs/f79bd64e-30d1-4119-8097-970fcb1907b0/images/363bd75ab86eeac9a7ae5688aa3c3a20e8cfabf7eb8905f8a0c6d7ed2c7e92a4.jpeg",
  templeArt: "https://static.prod-images.emergentagent.com/jobs/f79bd64e-30d1-4119-8097-970fcb1907b0/images/3b9ff026968056eaa47b7857ac489fc09e0d6b0f0a2f4adcb652b9e34bfa99c7.jpeg",
  marigold: "https://static.prod-images.emergentagent.com/jobs/f79bd64e-30d1-4119-8097-970fcb1907b0/images/363bd75ab86eeac9a7ae5688aa3c3a20e8cfabf7eb8905f8a0c6d7ed2c7e92a4.jpeg",
  diya: "https://static.prod-images.emergentagent.com/jobs/f79bd64e-30d1-4119-8097-970fcb1907b0/images/812e801686fad1731e2f8e6d7ac029a179c38be2aede2e01e21a1f6b11821b24.jpeg",
  temple: "https://static.prod-images.emergentagent.com/jobs/f79bd64e-30d1-4119-8097-970fcb1907b0/images/3b9ff026968056eaa47b7857ac489fc09e0d6b0f0a2f4adcb652b9e34bfa99c7.jpeg",
  gopuram: "https://static.prod-images.emergentagent.com/jobs/f79bd64e-30d1-4119-8097-970fcb1907b0/images/4f6d5b7405523b7fbfc9dc6146b2205dbd9b69c97ffee8edebc26432bd27bb62.jpeg",
  stars: "https://static.prod-images.emergentagent.com/jobs/f79bd64e-30d1-4119-8097-970fcb1907b0/images/c332f168c204d952d0c6a6d2c551fccd0291a78361a35f6ba15f0ef48a89b469.jpeg",
  diwali: "https://static.prod-images.emergentagent.com/jobs/f79bd64e-30d1-4119-8097-970fcb1907b0/images/363bd75ab86eeac9a7ae5688aa3c3a20e8cfabf7eb8905f8a0c6d7ed2c7e92a4.jpeg",
  holi: "https://static.prod-images.emergentagent.com/jobs/f79bd64e-30d1-4119-8097-970fcb1907b0/images/812e801686fad1731e2f8e6d7ac029a179c38be2aede2e01e21a1f6b11821b24.jpeg",
};

const DEITY = {
  ganesha: PIC.ganesha, ganesh: PIC.ganesha, ganapati: PIC.ganesha, vinayaka: PIC.ganesha,
  shiva: PIC.shiva, rudra: PIC.shiva, mahadev: PIC.shiva, shankar: PIC.shiva, nataraja: PIC.shiva,
  vishnu: PIC.vishnu, narayan: PIC.vishnu, venkate: PIC.vishnu, jagannath: PIC.vishnu, satyanarayan: PIC.vishnu, balaji: PIC.vishnu,
  krishna: PIC.krishna, govind: PIC.krishna, madhav: PIC.krishna, gopal: PIC.krishna,
  rama: PIC.rama, ram: PIC.rama,
  lakshmi: PIC.lakshmi, mahalakshmi: PIC.lakshmi, kubera: PIC.lakshmi,
  durga: PIC.devi, devi: PIC.devi, shakti: PIC.devi, parvati: PIC.devi, kali: PIC.devi, ambe: PIC.devi, gauri: PIC.devi,
  hanuman: PIC.hanuman,
  saraswati: PIC.saraswati,
  surya: PIC.surya, savitr: PIC.surya, aditya: PIC.surya, navagraha: PIC.surya,
};
const TYPE = {
  katha: PIC.manuscript, mantra: PIC.mantraArt, puja_vidhi: PIC.pujaArt,
  stotra: PIC.stotraArt, vedic: PIC.manuscript, festival: PIC.festivalArt, sukta: PIC.stotraArt,
};
const KIND = {
  pooja: PIC.pujaArt, homam: PIC.diya, yagya: PIC.diya, astrology: PIC.stars,
  numerology: PIC.manuscript, vastu: PIC.temple, panchang: PIC.manuscript, muhurt: PIC.diwali,
};
const OCCASION = { diwali: PIC.diwali, holi: PIC.holi, navratri: PIC.devi, shivratri: PIC.shiva };

const norm = (s) => (s || "").toLowerCase();

const BACKEND = process.env.REACT_APP_BACKEND_URL || "";

// Normalise any stored media URL so it always resolves on the CURRENT domain.
// Uploads are served from shared Emergent object storage via `/api/media/...`,
// which works on every environment (preview + production). Older records saved
// the FULL url with whatever domain they were uploaded on — that domain goes
// stale after a fork/deploy and 404s. We strip it back to the same-origin
// `/api/media/...` path; external CDN/Unsplash urls pass through untouched.
export function normalizeSrc(url) {
  if (!url || typeof url !== "string") return url;
  const i = url.indexOf("/api/media/");
  if (i >= 0) return url.slice(i);
  return url;
}
// Absolute variant for hrefs / clipboard (prefixes the current backend origin).
export function absMedia(url) {
  const n = normalizeSrc(url);
  return n && n.startsWith("/") ? `${BACKEND}${n}` : n;
}

// Route any image (external CDN, Unsplash, or an /api/media upload) through the
// backend resize+cache proxy so cards load a small, same-origin, permanently
// cached thumbnail — the fix for broken/blank card art on throttled mobile data.
export function imgSrc(url, w = 640) {
  const n = normalizeSrc(url);
  if (!n || typeof n !== "string") return n;
  if (n.startsWith("data:") || n.startsWith("blob:")) return n;
  const abs = n.startsWith("/") ? `${BACKEND}${n}` : n;
  return `${BACKEND}/api/img?src=${encodeURIComponent(abs)}&w=${w}`;
}

// Default homepage section-gateway banners (distinct art per section). Admins can
// override any of these (and the hero) via Admin → Homepage Images.
export const HOME_TILES = {
  deities: "https://static.prod-images.emergentagent.com/jobs/f79bd64e-30d1-4119-8097-970fcb1907b0/images/058e25a8c4aa7ed9ef38ee0a25b8ed8503715d3a0eeb493099d2e3e9c4981210.jpeg",
  mantras: "https://static.prod-images.emergentagent.com/jobs/f79bd64e-30d1-4119-8097-970fcb1907b0/images/dbfc1eefb8941bb391d2ff9150059099b81c941151f6c37129cb82adc6c63296.jpeg",
  stotras: "https://static.prod-images.emergentagent.com/jobs/f79bd64e-30d1-4119-8097-970fcb1907b0/images/590e01daf5465d3b12c48fcc371a606995e22f96c1e4679e5ab54699adb60da0.jpeg",
  "puja-vidhi": "https://static.prod-images.emergentagent.com/jobs/f79bd64e-30d1-4119-8097-970fcb1907b0/images/22bcf64d40ac76fbed079b9abba9cc1652d3b627f09f731c9e6ffd5fc9b18c56.jpeg",
  temples: "https://static.prod-images.emergentagent.com/jobs/f79bd64e-30d1-4119-8097-970fcb1907b0/images/4f6d5b7405523b7fbfc9dc6146b2205dbd9b69c97ffee8edebc26432bd27bb62.jpeg",
  scriptures: "https://static.prod-images.emergentagent.com/jobs/f79bd64e-30d1-4119-8097-970fcb1907b0/images/8ed65143cdae7f70caba2ac3968dc96ee84dc99fd01cb59aee585baac2d4736b.jpeg",
  suktas: "https://static.prod-images.emergentagent.com/jobs/f79bd64e-30d1-4119-8097-970fcb1907b0/images/fbdea4bdb4eacf0b112cc3ca784bc67ea79ed9e58bdd5a946bd9e390bd137783.jpeg",
  festivals: "https://static.prod-images.emergentagent.com/jobs/f79bd64e-30d1-4119-8097-970fcb1907b0/images/812e801686fad1731e2f8e6d7ac029a179c38be2aede2e01e21a1f6b11821b24.jpeg",
};

function scan(text, table) {
  const t = norm(text);
  for (const key of Object.keys(table)) if (t.includes(key)) return table[key];
  return null;
}

function resolve({ deity, occasion, type, kind, tags, name }) {
  return (
    scan(deity, DEITY) ||
    scan(occasion, OCCASION) ||
    scan(name, DEITY) ||
    scan(name, OCCASION) ||
    scan((tags || []).join(" "), DEITY) ||
    (kind && KIND[kind]) ||
    (type && TYPE[type]) ||
    PIC.templeArt
  );
}

// Some stored records hotlink images.unsplash.com, which is unreliable on many
// real mobile networks (blocked/slow → blank cards or broken icons). Treat those
// as "not present" so we fall back to the reliable self-hosted deity/type artwork.
const isUnreliable = (u) => typeof u === "string" && /images\.unsplash\.com/i.test(u);

export function resolveImage(item) {
  if (!item) return PIC.templeArt;
  const explicit = [item.image_url, item.image, item.cover, item.preview_image].find((u) => u && !isUnreliable(u));
  if (explicit) return normalizeSrc(explicit);
  // Admin-mapped Deity (category) artwork — drives the card when no reliable photo.
  if (item.deity_image && !isUnreliable(item.deity_image)) return normalizeSrc(item.deity_image);
  return resolve({
    deity: item.deity, occasion: item.occasion, type: item.type, tags: item.tags,
    name: `${item.devanagari_title || ""} ${item.title || ""} ${item.category || ""}`,
  });
}

export function resolveServiceImage(svc) {
  if (!svc) return PIC.templeArt;
  return resolve({
    deity: svc.deity, occasion: svc.occasion, kind: svc.kind,
    name: `${svc.name || ""} ${svc.category || ""}`,
  });
}

export function resolveKindImage(kind) {
  return KIND[kind] || PIC.templeArt;
}

// onError handler: if a content image fails to load (e.g. a broken /api/media
// path), swap in a deterministic type-based artwork instead of a broken icon.
export function fallbackFor(item) {
  if (!item) return PIC.templeArt;
  if (item.deity_image && !isUnreliable(item.deity_image)) return normalizeSrc(item.deity_image);
  return resolve({ deity: item.deity, occasion: item.occasion, type: item.type, tags: item.tags,
    name: `${item.devanagari_title || ""} ${item.title || ""} ${item.category || ""}` });
}
export const onImgError = (item) => (e) => {
  const fb = imgSrc(fallbackFor(item), 700);
  if (e.currentTarget.src !== fb) { e.currentTarget.onerror = null; e.currentTarget.src = fb; }
};
